import * as React from "react";
import { DropDownContainer } from "./DropDown.styled";
import { Menu } from "../../../../../../interfaces/menu/menu.interface";
import { HTMLAttributes } from "react";
import { DropDownItem } from "./DropDownItem";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { INSTRUMENT_NAME } from "../../../../../../constants";
import { InstrumentUnion } from "../../../../../../types/instrument.type";

interface DropDownProps extends HTMLAttributes<HTMLDivElement> {
	isShow: boolean;
	items: Menu[];
}

export const DropDown = observer(({ isShow, items }: DropDownProps) => {
	const { t } = useTranslation();

	return (
		<DropDownContainer show={isShow}>
			{items.map((item) => {
				item = {
					...item,
					...{
						name: t(`instruments.${item.name.toLowerCase() as InstrumentUnion}`),
					},
				};

				return <DropDownItem key={item.link} item={item} />;
			})}
		</DropDownContainer>
	);
});
